module.exports = __webpack_public_path__ + "img/106028.2dbf46de.png";